// extracted by mini-css-extract-plugin
export default {"form":"PageDataInputs_form__R40Ta","section-data":"PageDataInputs_section-data__oqX6I","div-button":"PageDataInputs_div-button__VdTus"};